import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { APP_MODULES } from 'constants/appModules';
import { GLOBAL_BENCHMARK_MODULES } from 'constants/globalBenchmarkModules';
import { PLANNING_MODULES } from 'constants/planningPanelModules';

export type customDisabledTabConditionsState = Readonly<{
  [APP_MODULES.GLOBAL_BENCHMARK]: {
    [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_TIME_BREAKDOWN]: boolean;
    [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_BOP_OPERATIONS]: boolean;
    [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_DRILLING]: boolean;
    [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_TRIPPING]: boolean;
    [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_CASING_RUNNING]: boolean;
  };
  [APP_MODULES.PLANNING_PANEL]: {
    [PLANNING_MODULES.PLANNING_OFFSET_SEQUENCES]: boolean;
    [PLANNING_MODULES.PLANNING_OFFSET_TIME_BREAKDOWN]: boolean;
    [PLANNING_MODULES.PLANNING_OFFSET_TIME_VS_DEPTH]: boolean;
  };
}>;

export const initialState: customDisabledTabConditionsState = {
  [APP_MODULES.GLOBAL_BENCHMARK]: {
    [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_TIME_BREAKDOWN]: true,
    [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_BOP_OPERATIONS]: true,
    [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_DRILLING]: true,
    [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_TRIPPING]: true,
    [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_CASING_RUNNING]: true,
  },
  [APP_MODULES.PLANNING_PANEL]: {
    [PLANNING_MODULES.PLANNING_OFFSET_SEQUENCES]: true,
    [PLANNING_MODULES.PLANNING_OFFSET_TIME_BREAKDOWN]: true,
    [PLANNING_MODULES.PLANNING_OFFSET_TIME_VS_DEPTH]: true,
  },
};

const customDisabledTabConditionsSlice = createSlice({
  name: 'CustomModuleTabLinks',
  initialState,
  reducers: {
    updateGlobalBenchmarkTabsCondition: (state, action: PayloadAction<boolean>) => {
      state.GLOBAL_BENCHMARK = {
        [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_TIME_BREAKDOWN]: action.payload,
        [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_BOP_OPERATIONS]: action.payload,
        [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_DRILLING]: action.payload,
        [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_TRIPPING]: action.payload,
        [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_CASING_RUNNING]: action.payload,
      };
    },

    updatePlanningTabsCondition: (state, action: PayloadAction<boolean>) => {
      state.PLANNING_PANEL = {
        [PLANNING_MODULES.PLANNING_OFFSET_SEQUENCES]: action.payload,
        [PLANNING_MODULES.PLANNING_OFFSET_TIME_BREAKDOWN]: action.payload,
        [PLANNING_MODULES.PLANNING_OFFSET_TIME_VS_DEPTH]: action.payload,
      };
    },
  },
});

export const { updateGlobalBenchmarkTabsCondition, updatePlanningTabsCondition } =
  customDisabledTabConditionsSlice.actions;
export default customDisabledTabConditionsSlice.reducer;
